import React, { memo, MouseEvent, useMemo } from 'react';
import styled from 'styled-components';
import FormikSelect from '@minecraft.formik-select';
import { gqlFilterOperator, gqlProfileSearchInput, gqlSearchResultType } from '@minecraft.graphql-types';
import { Trans, useTranslation } from '@blocs.i18n';

const Container = styled.div`
  display: flex;
  font-size: 11px;
  border: 1px solid #d8d8d8;
  background: #ededed;
  align-items: baseline;
  padding: 4px 8px 4px 8px;

  & > div {
    margin: 0 2px;
  }
`;

const StyledFormikSelect = styled(FormikSelect)`
  font-size: 14px;
  line-height: 20px;
`;

const SkillOperatorSelect = ({ onChange }): JSX.Element => {
  const { t } = useTranslation();

  const options = useMemo(() => {
    return [
      { value: gqlFilterOperator.OR, label: t('common:label.filter.skillOperator.any') },
      { value: gqlFilterOperator.AND, label: t('common:label.filter.skillOperator.all') },
    ];
  }, [t]);

  return <StyledFormikSelect onChange={onChange} name="skillOperator" size="small" options={options} />;
};

type Props = {
  refetchProfileFilterData?: ({
    input,
    resultType,
  }: {
    input: Record<string, unknown>;
    resultType: gqlSearchResultType.FACETS;
  }) => void;
  appliedQueryInput?: gqlProfileSearchInput;
};

const SkillsOperator = ({ refetchProfileFilterData, appliedQueryInput }: Props): JSX.Element => {
  const handleSkillOperatorChange = (e: MouseEvent<HTMLSelectElement>): void => {
    if (refetchProfileFilterData) {
      const skillOperator = e.target.value as gqlFilterOperator;
      refetchProfileFilterData({
        input: {
          profileStatusToSearch: appliedQueryInput?.profileStatusToSearch,
          skills: appliedQueryInput?.skills || [],
          skillOperator,
        },
        resultType: gqlSearchResultType.FACETS,
      });
    }
  };

  return (
    <Container>
      <Trans
        i18nKey="common:label.filter.skillOperator.description"
        components={[<SkillOperatorSelect onChange={handleSkillOperatorChange} />]}
      />
    </Container>
  );
};

export default memo(SkillsOperator);
